<template>
    <div class="d-flex" style="height: 100%;">
        <!-- Backdrop mobile -->
        <Transition name="fade">
            <div
                v-if="sidebarOpen"
                class="d-lg-none position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
                style="z-index: 1040;"
                @click="sidebarOpen = false"
            />
        </Transition>

        <AppSidebar :is-open="sidebarOpen" @close="sidebarOpen = false" />

        <div class="flex-grow-1 d-flex flex-column min-w-0">
            <AppHeader @open-sidebar="sidebarOpen = true" />

            <main class="flex-grow-1 bg-light overflow-auto">
                <RouterView />
            </main>
        </div>
    </div>
    <ConfirmModal />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import AppSidebar from './AppSidebar.vue'
import AppHeader from './AppHeader.vue'
import ConfirmModal from '@/components/ConfirmModal.vue'
import { usePageHeader } from '@/composables/usePageHeader'
import { useBreadcrumbs } from '@/composables/useBreadcrumbs'

const sidebarOpen = ref(false)
const { title, mobileTitle } = usePageHeader()
const { crumbs } = useBreadcrumbs()

useRouter().beforeEach(() => {
    title.value = ''
    mobileTitle.value = ''
    crumbs.value = []
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
